
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesInvoiceComparison"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimension"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisDimension"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measure"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisMeasure"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leftComparison"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialCalendarInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rightComparison"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialCalendarInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dimensionFilters"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DimensionFilterInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comparative"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Direction"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"salesInvoiceComparison"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"breakdownDimension"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimension"}}},{"kind":"Argument","name":{"kind":"Name","value":"measure"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measure"}}},{"kind":"Argument","name":{"kind":"Name","value":"leftComparison"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leftComparison"}}},{"kind":"Argument","name":{"kind":"Name","value":"rightComparison"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rightComparison"}}},{"kind":"Argument","name":{"kind":"Name","value":"dimensionFilters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dimensionFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"comparative"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comparative"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortDirection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortDirection"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dimensionId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"left_comparison_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"right_comparison_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"difference"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":677}};
    doc.loc.source = {"body":"query salesInvoiceComparison(\n  $dimension: AnalysisDimension\n  $measure: AnalysisMeasure\n  $leftComparison: FinancialCalendarInput\n  $rightComparison: FinancialCalendarInput\n  $dimensionFilters: [DimensionFilterInput]\n  $comparative: Boolean\n  $sortDirection: Direction\n) {\n  data: salesInvoiceComparison(\n    breakdownDimension: $dimension\n    measure: $measure\n    leftComparison: $leftComparison\n    rightComparison: $rightComparison\n    dimensionFilters: $dimensionFilters\n    comparative: $comparative\n    sortDirection: $sortDirection\n  ) {\n    uuid\n    reference\n    description\n    dimensionId\n    left_comparison_value\n    right_comparison_value\n    difference\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["salesInvoiceComparison"] = oneQuery(doc, "salesInvoiceComparison");
        
